import { FieldValues, UseFormSetError } from 'react-hook-form';
import { handleErrorForm } from '@services/api';
import { TransactionFile } from 'interfaces/TransactionFile';
import { formatCurrency, formatValue } from 'utils/string/currency';
import {
  TransactionFilters,
  create,
  list,
  remove,
  retrieve,
  update,
} from './calls';

export * from './calls';

export default class TransactionAPICaller {
  static adaptFromAPI = (data: TransactionFile) =>
    ({
      ...data,
      amount: formatCurrency((data.amount as number) / 100),
    } as FieldValues);

  static adaptToAPI = (data: FieldValues) => {
    // Math.round: float64 makes many cent values inexact (8.2 * 100 ===
    // 819.9999999999999) and the API column is an integer.
    const amount =
      typeof data.amount === 'number'
        ? data.amount
        : Math.round(formatValue(data.amount) * 100);

    const transaction = {
      ...data,
      amount,
    };

    return transaction as TransactionFile;
  };

  static list = async (filters: TransactionFilters) => {
    const {
      data: { transactions },
    } = await list(filters);

    return {
      ...transactions,
      result: transactions?.result.map(this.adaptFromAPI),
    };
  };

  static fetch = async (editId: string) => {
    const {
      data: { transaction },
    } = await retrieve(editId);

    // Same adaptation the table (list) applies: the edit form receives the
    // amount already formatted ("R$ 1.234,56"), not raw integer cents —
    // adaptToAPI converts it back on save.
    return this.adaptFromAPI(transaction);
  };

  static createOrUpdate = async (
    data: FieldValues,
    setError: UseFormSetError<FieldValues>
  ) => {
    const method = data.id ? update : create;
    const result = method(this.adaptToAPI(data)).catch(
      handleErrorForm(setError)
    );

    return result;
  };

  static remove = async (id: string) => {
    const { data } = await remove(id);

    return data;
  };
}
